import { Floor } from '@/types/floor'

// The floors API has no guaranteed ordering, so a floor's 1-based "level
// position" (used to match a hand-entered metadata.floorId like 1/2/3) is
// derived by sorting by id ascending - real floor ids are created in level
// order (Level 1's id < Level 2's id < Level 3's id).
export const getFloorPositionInLocation = (
  floors: Floor[] | undefined,
  floorId: number | undefined,
): number => {
  if (!floors?.length || !floorId) return 0
  const sorted = [...floors].sort((a, b) => a.id - b.id)
  return sorted.findIndex((f) => f.id === floorId) + 1
}
